<template>
  <transition name="fade" appear>
    <div class="app" v-if="!isLoading">
      <div class="app__header">
        <VBlock>
          <img src="@/assets/app-logo.png" />
        </VBlock>
      </div>

      <div class="app__content">
        <div class="app__section">
          <div class="app__section-content">
            <VText big center>
              opowiedz nam <span>co cię przeraża</span><br />
              i wygraj jedną z super nagród!
            </VText>

            <VBlock max-width="708px">
              <img src="@/assets/cta-prizes.png" />
            </VBlock>

            <div class="app__buttons">
              <VBlock max-width="320px">
                <transition name="bounceUp" appear>
                  <VButton v-scroll-to="'#rules'">Sprawdź zasady</VButton>
                </transition>
              </VBlock>

              <VBlock max-width="320px">
                <transition name="bounceUp" appear>
                  <VButton v-scroll-to="'#contest'">Laureaci</VButton>
                </transition>
              </VBlock>
            </div>
          </div>

          <VBlock>
            <img src="@/assets/cta-footer.png" />
          </VBlock>
        </div>

        <div class="app__section" id="rules">
          <div class="app__section-content">
            <VText center>Zasady</VText>

            <VText small>1. za pomocą formularza napisz w kilku zdaniach <span>czego najbardziej się boisz.</span></VText>
            <VText small>2. WSPÓLNIE Z OPIEKUNEM <span>UZUPEŁNIJ FORMULARZ OSOBOWY</span> ABYŚMY MOGLI SIĘ Z WAMI SKONTAKTOWAĆ W&nbsp;PRZYPADKU WYGRANEJ.</VText>
            <VText small>3. JURY NAGRODZI <span>NAJBARDZIEJ KREATYWNE I ORYGINALNE historie!</span></VText>
            <VText small center>KONKURS TRWA OD 18.10 DO 29.10.2023.<br />SZCZEGÓŁY ZNAJDZIESZ W <a href="regulamin.pdf" target="_blank">regulaminie.</a></VText>

            <VBlock max-width="320px">
              <transition name="bounceUp" appear>
                <VButton v-scroll-to="'#contest'">Laureaci</VButton>
              </transition>
            </VBlock>
          </div>

          <VBlock>
            <img src="@/assets/rules-footer.png" />
          </VBlock>
        </div>

        <div class="app__section" id="prizes">
          <div class="app__section-content">
            <VText center>Nagrody</VText>

            <VBlock>
              <img src="@/assets/prizes.png" />
            </VBlock>

            <VBlock max-width="320px">
              <transition name="bounceUp" appear>
                <VButton v-scroll-to="'#contest'">Laureaci</VButton>
              </transition>
            </VBlock>
          </div>

          <VBlock>
            <img src="@/assets/prizes-footer.png" />
          </VBlock>
        </div>

        <div class="app__section" id="contest">
          <div class="app__section-content">
            <transition name="fade" mode="out-in" appear>
              <router-view :key="$route.fullPath" v-if="!isLoading" />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { RESET_LOADING, BEGIN_LOADING, END_LOADING } from '@/store';
import config from '@/config';

export default {
  name: 'App',

  created() {
    const { languageCode } = config;

    this.$store.commit(RESET_LOADING);

    this.loadDictionary(languageCode);
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },

  methods: {
    async loadDictionary(languageCode) {
      const FAKE_DELAY = 500;

      this.$store.commit(BEGIN_LOADING);

      this.$i18n.setLocaleMessage(
        languageCode,
        (await this.$bricodes.getDictionary(languageCode)).data,
      );

      this.$i18n.locale = languageCode;

      setTimeout(() => {
        this.$store.commit(END_LOADING);
      }, FAKE_DELAY);
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';
@import '~animate.css/animate.min.css';

@font-face {
  font-family: 'Bangers';
  src: url('~@/assets/Bangers-Regular.woff2') format('woff2'),
    url('~@/assets/Bangers-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  background-image: url('~@/assets/body-background-center.png'), url('~@/assets/body-background-cover.png');
  background-repeat: no-repeat, no-repeat;
  background-size: auto auto, cover;
  background-attachment: fixed, fixed;
  background-position: center 200px, center center;
}

.app {
  overflow: hidden;

  display: flex;
  flex-direction: column;

  min-height: 100%;
  max-width: $appWidth;
  margin: 0 auto;

  font-family: Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  &__header {
    position: relative;
    margin-bottom: -10%;
  }

  &__content {
    background-color: #19162a;
    flex: 1 1 auto;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: calc($gridGutter * 2);

    @media screen and (max-width: 960px) {
      display: block;
    }

    .block:not(:first-child) {
      margin-top: 0 !important;

      @media screen and (max-width: 960px) {
        margin-top: $gridGutter !important;
      }
    }
  }

  &__section {
    padding: calc($gridGutter * 2) 0 0;

    &:first-child {
      padding-top: 12%;
    }

    &:last-child {
      padding-top: $gridGutter;
    }

    &:nth-child(2) {
      background-color: #211f2b;
      background-image: url('~@/assets/section-artwork-1.png');
      background-repeat: no-repeat;
      background-position: top 20px left 20px;
    }

    &:nth-child(3) {
      background-image: url('~@/assets/section-artwork-2.png');
      background-repeat: no-repeat;
      background-position: top 20px right 20px;
    }

    &:nth-child(4) {
      background-image: url('~@/assets/section-artwork-3.png');
      background-repeat: no-repeat;
      background-position: top 20px left 20px;
    }

    @media screen and (max-width: 960px) {
      background-size: auto 100px;
    }

    @media screen and (max-width: 540px) {
      background-image: none !important;
    }
  }

  &__section-content {
    padding: 0 calc($gridGutter * 2);

    & > .text:first-child {
      margin-bottom: calc($gridGutter * 2);
    }

    @media screen and (max-width: 960px) {
      padding: 0 $gridGutter;
    }
  }
}
</style>
